import { DcBaseComponent } from '@deleteagency/dc';
import { render } from 'preact';
import React from 'preact/compat';
import StampDutyCalculator from './stamp-duty-calculator';

export default class StampDutyCalculatorComponent extends DcBaseComponent {
    constructor(...args) {
        super(...args);
    }

    static getNamespace() {
        return 'stamp-duty-calculator';
    }

    static getRequiredRefs() {
        return [
            'placeholder'
        ]
    }

    onInit() {
        this._render();
    }

    _render() {
        const value = this.options.propertyValue ? this.options.propertyValue > 0 ? this.options.propertyValue : '' : '';

        render(
            <StampDutyCalculator
                priceLabel={this.options.priceLabel}
                firstTimeBuyerLabel={this.options.firstTimeBuyerLabel}
                secondHomeLabel={this.options.secondHomeLabel}
                nonResidentLabel={this.options.nonResidentLabel}
                buttonLabel={this.options.buttonLabel}
                propertyValue={value}
                valueError={this.options.valueError}
                toPayLabel={this.options.toPayLabel}
                effectiveRateLabel={this.options.effectiveRateLabel}
                taxBandLabel={this.options.taxBandLabel}
                percentageLabel={this.options.percentageLabel}
                taxableSumLabel={this.options.taxableSumLabel}
                taxLabel={this.options.taxLabel}
                bands={this.options.bands}
                firstTimeBuyerLimit={this.options.firstTimeBuyerLimit}
                widgetType={this.options.type || 'PROPERTY'}
                ></StampDutyCalculator>,
            this.refs.placeholder,
        );
    }
}
